import React from 'react';
import { useField, useFormikContext } from 'formik';
import { Input } from 'reactstrap';
import FieldWrapper from './FieldWrapper';

const getValueByType = (value, type) => {
  if (type === 'number') {
    return !!Number(value) ? Number(value) : value;
  }
  if (type === 'string') {
    return value?.toString();
  }
  return value
}

const FormikCheckboxGroup = (props) => {
  const {
    name,
    title,
    className,
    fieldClassName,
    inputClassName = '',
    items,
    typeValue = 'string', // string | number
    ...restProps
  } = props;
  const [field] = useField(name);
  const { value: values = [] } = field || {}
  const { setFieldValue } = useFormikContext();

  const handleChange = (e) => {
    const { value, checked } = e?.target || {}
    const newValues = checked ? [...values, getValueByType(value, typeValue)] : values.filter(i => getValueByType(i, typeValue) !== getValueByType(value, typeValue));
    setFieldValue(name, newValues);
  }

  return (
    <FieldWrapper
      name={name}
      label={title}
      fieldClassName={fieldClassName}
      className={className}
    >
      {items?.map((item) => (
        <div className={`form-check mb-1 ${inputClassName}`} key={item.value}>
          <label className="form-check-label">
            <Input
              name={name}
              type="checkbox"
              className="form-check-input"
              checked={values?.includes(getValueByType(item?.value, typeValue))}
              onChange={handleChange}
              value={item.value}
              {...restProps}
            />
            {item.label}
          </label>
        </div>
      ))}
    </FieldWrapper>
  );
};

export default FormikCheckboxGroup;
